<template>
  <div class="card card-admin">
    <div class="card-body">
      <div class="form-group">
        <img class="img-thumbnail image-preview" :src="editedCategory.backgroundimage"
          v-if="editedCategory.backgroundimage" alt="Anteprima immagine" />
        <p style="text-align: center;" v-else>Anteprima immagine non disponibile</p>
      </div>
      <div class="form-group">
        <label for="title">Titolo categoria:</label>
        <input type="text" class="form-control" id="title" v-model="editedCategory.title"
          placeholder="Inserisci il titolo della categoria" />
      </div>
      <div class="form-group">
        <ImageUploader @image-selected="handleFileSelected" />
      </div>

      <div class="button-group">
        <button class="btn btn-primary apply-button" @click="handleApplyChanges">Applica modifiche</button>
        <button class="btn btn-danger delete-button" @click="showConfirmationPopup">Elimina categoria</button>
      </div>
      <div v-if="showModal" class="modal-container">
        <GenericModal message="Sei sicuro di voler eliminare questa categoria?" @confirmed="handleDeleteCategory"
          @canceled="hideConfirmationPopup"></GenericModal>
      </div>
    </div>
  </div>
</template>

<script>
import { updateCategory, deleteCategory } from '@/api/CategoryAPI';
import { uploadImage, deleteImageByUrl } from '@/utils/firebaseImageUploader';
import ImageUploader from '@/components/adminpage/ImageUploader.vue';
import GenericModal from '@/components/adminpage/GenericModal'

export default {
  components: {
    ImageUploader,
    GenericModal,
  },
  props: {
    category: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      editedCategory: { ...this.category },
      showModal: false,
    };
  },
  methods: {
    handleFileSelected(file) {
      this.editedCategory.backgroundimage = file;
    },
    showConfirmationPopup() {
      this.showModal = true;
    },
    hideConfirmationPopup() {
      this.showModal = false;
    },
    async handleApplyChanges() {
      let imageUrl = this.editedCategory.backgroundimage;
      if (this.editedCategory.backgroundimage !== this.category.backgroundimage) {
        if (this.editedCategory.backgroundimage) {
          imageUrl = await uploadImage(this.editedCategory.backgroundimage);
        }
      }
      this.editedCategory.backgroundimage = imageUrl;
      await updateCategory(this.editedCategory.id, this.editedCategory);
      this.$emit('refresh-category');
    },
    async handleDeleteCategory() {
      this.hideConfirmationPopup();
      if (this.editedCategory.backgroundimage) {
        await deleteImageByUrl(this.editedCategory.backgroundimage);
      }
      await deleteCategory(this.editedCategory.id);
      this.$emit('refresh-category');
    },
  }
};
</script>

<style scoped>
.card-admin {
  padding-top: 30px;
  border: none;
  background-color: transparent;
  margin: 20px;
  margin-bottom: 0px;
  padding-bottom: 30px;
}

.form-group {
  margin-bottom: 20px;
  padding-left: 15px;
  padding-right: 15px;
}

.apply-button,
.delete-button {
  margin: auto;
}

.image-preview {
  max-width: 100%;
  height: auto;
  display: block;
  margin: auto;
}

.card-body {
  color: var(--text-color);
  background-color: var(--secondary-color);
  box-shadow: var(--custom-box-shadow);
  border-radius: 20px;
}

.button-group {
  display: flex;
  margin-top: 40px;
  margin-bottom: 15px;
}

.newCategory-title {
  color: var(--text-color);
  background-color: var(--accent-color);
  text-align: center;
  margin: auto;
  margin-bottom: 20px;
  border-radius: 25px;
  border: solid 2px;
  border-color: var(--border-color);
  box-shadow: var(--custom-box-shadow);
}

.newCategory-title h1 {
  padding: 10px;
}
</style>